"use client";

import { ArrowRight, Lock } from "lucide-react";
import { Badge } from "@/components/ui/Badge";
import { Button } from "@/components/ui/Button";

export function InviteForm({ inviteCode, onCodeChange, onVerify }: {
  inviteCode: string;
  onCodeChange: (code: string) => void;
  onVerify: () => Promise<void>;
}) {

  return (
    <div className="space-y-8 animate-in fade-in duration-300 max-w-md mx-auto text-center pt-10">
      <div>
        <Badge variant="clay" className="mb-4">
          <Lock className="w-3 h-3 text-clay inline mr-1" />
          Private Beta
        </Badge>
        <h1 className="text-3xl sm:text-4xl font-bold text-ink tracking-tight">
          Welcome to Curated Den
        </h1>
        <p className="text-sm text-ink-soft mt-3">
          We are currently in a closed beta to manage AI generation costs. Please enter your invite code to begin your room transformation.
        </p>
      </div>

      <div className="space-y-4">
        <input
          type="text"
          placeholder="Enter Invite Code"
          value={inviteCode}
          onChange={(e) => onCodeChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onVerify();
            }
          }}
          className="w-full px-4 py-3 bg-paper rounded-xl border border-line text-sm focus:outline-none focus:ring-2 focus:ring-clay/40 text-center"
        />
        <Button
          type="button"
          size="lg"
          className="w-full gap-2 cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            onVerify();
          }}
        >
          <span>Enter</span>
          <ArrowRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
